export default "__VITE_ASSET__DvXzLyOk__"